<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend />
    </section>
    <section class="section">
        <header class="lcu-section-header">Mi Cuenta</header>
        <div class="lcu-tabs-container">
            <button
                :class="{
                    'lcu-tab-buttonActive':
                        $router.currentRoute.value.path.match(/^\/cuenta\/perfil/gi),
                }"
                @click.prevent="checkLink('/cuenta/perfil')"
                class="lcu-tab-button">
                Perfil
            </button>
            <button
                :class="{
                    'lcu-tab-buttonActive':
                        $router.currentRoute.value.path.match(/^\/cuenta\/facturacion/gi),
                }"
                @click.prevent="checkLink('/cuenta/facturacion')"
                class="lcu-tab-button">
                Facturación
            </button>
            <button
                :class="{
                    'lcu-tab-buttonActive':
                        $router.currentRoute.value.path.match(/^\/cuenta\/preferencias/gi),
                }"
                @click.prevent="checkLink('/cuenta/preferencias')"
                class="lcu-tab-button">
                Preferencias
            </button>
        </div>
        <div class="lcu-tabcontent-container" v-if="!userLoading">
          <router-view />
        </div>
        <div class="row row-center" v-if="userLoading">
          <spin-loader :size="'100px'" />
        </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import Announement from 'ç/announcement/Announcement.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';

export default {
  name: 'account-page',
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  components: {
    PageLegend,
    SpinLoader,
    'annoucement-banner': Announement,
  },
  data() {
    return {
    };
  },
  methods: {
    checkLink(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-tabs-container {
    border-bottom: 2px solid $gray-lightest;
    margin-bottom: 35px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.lcu-tab-button {
    border: 0;
    border-bottom: 3px solid $white;
    padding: 13px 25px 10px;
    font-size: 16px;
    color: $gray-medium;
    transition-duration: .2s;
    color: $legacy-primary;
    background-color: $white;
    font-family: raleway-medium;

    &:hover {
        cursor: pointer;
        background-color: $off-white;
    }

    @media only screen and (max-width: $mobile-max) {
        padding-left: 12px;
        padding-right: 12px;
    }
}

.lcu-tab-buttonActive {
    border-bottom: 3px solid $legacy-primary;
    font-family: raleway-bold;
}
</style>
